import { Controller } from "@hotwired/stimulus";

export default class NumericController extends Controller {
  connect() {
    this.element.addEventListener("keydown", this.validateKey);
  }

  disconnect() {
    this.element.removeEventListener("keydown", this.validateKey);
  }

  validateKey = (event) => {
    const allowedKeys = [
      "Backspace",
      "Enter",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "Tab"
    ];

    if (!/^\d$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  };
}
